// removed by extract-text-webpack-plugin
    if(module.hot) {
      // 1647875994013
      var cssReload = require("!../../../node_modules/css-hot-loader/hotModuleReplacement.js")(module.id, {"fileMap":"{fileName}"});
      module.hot.dispose(cssReload);
      module.hot.accept(undefined, cssReload);;
    }
  


//////////////////
// WEBPACK FOOTER
// ./src/views/Notifications/style.scss
// module id = ./src/views/Notifications/style.scss
// module chunks = 103